export function getBrowserId(): string {
  const BROWSER_ID_KEY = 'browserId';
  
  // Check if browserId already exists in localStorage
  let browserId = localStorage.getItem(BROWSER_ID_KEY);
  
  if (!browserId) {
    // Generate a new GUID if it doesn't exist
    browserId = generateGUID();
    localStorage.setItem(BROWSER_ID_KEY, browserId);
  }
  
  return browserId;
}

// Debug function to help identify issues
export function debugBrowserId(): void {
  // Debug function - no-op in production
}

function generateGUID(): string {
  // Generate a random GUID (UUID v4 format)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
